import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BazisInputFileButtonComponent } from '@bazis/form/components/base/inputs/input-file-button.component';
import { v4 as uuidv4 } from 'uuid';

@UntilDestroy()
@Component({
    selector: 'app-input-file-button',
    templateUrl: './input-file-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AppInputFileButtonComponent extends BazisInputFileButtonComponent {
    files: { id: string; file: File; extension: string }[] = [];

    addFiles(e) {
        const element = e.currentTarget as HTMLInputElement;
        let fileList: FileList | null = element.files;

        for (let index = 0; index < fileList.length; index++) {
            const file = fileList[index];
            const id = `${uuidv4()}`;
            if (this.files.length < this.max) {
                this.uploadingDict[id] = { status: 'empty' };
                this.files.push({ id, file, extension: file.name.split('.').pop() });
            }
            this.preUploadFile(file, element, id);
            if (!this.uploadingDict[id]) return;

            this.uploadFile(file, id);
        }
        this.markAsTouched();
        element.value = '';
    }

    updateFormControl() {
        const values = this.files.filter((v) => v && !this.uploadingDict[v.id]).map((v) => v.file);
        if (values.length !== this.files.length) return;
        this.onChange(this.max > 1 ? values : values.length ? values[0] : null);
    }
}
